export default function kibritAdmin ({ next, store }){
    if(store.getters.getUserRole !== "SuperAdmin"){
        return next({
           name: 'dashboard'
        })
    }
   
    return next()
   }